module.exports = __webpack_public_path__ + "img/signin_bg.047557d3.png";